<!-- Shape Start -->
<div class="position-relative">
  <div class="shape overflow-hidden">
    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
    </svg>
  </div>
</div>
<!--Shape End-->

<!-- Footer Start -->
<footer class="footer">
  <div class="container">
    <div class="row">
      <div class="col-lg-4 col-12">
        <a href="#" class="logo-footer">
          <img src="../../../../assets/images/logo white.webp" width="250" alt="logo" loading="lazy">
        </a>
        <p>{{ 'Footer.p' | translate }}</p>
        <ul class="list-unstyled social-icon foot-social-icon">
          <li class="list-inline-item"><a href="https://www.facebook.com/EasykashEg/" target="_blank" class="rounded"><i
                class="uil uil-facebook-f "></i></a></li>
          <li class="list-inline-item"><a href="https://www.instagram.com/easykasheg/" target="_blank"
              class="rounded"><i class="uil uil-instagram"></i></a></li>
          <li class="list-inline-item"><a href="https://www.linkedin.com/company/easykasheg/" target="_blank"
              class="rounded"><i class="uil uil-linkedin-alt"></i></a></li>
        </ul><!--end icon-->
      </div><!--end col-->

      <div class=" footer-col col-lg-2 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
        <h5 class="text-light footer-head">{{ 'Footer.footerHead.Company' | translate }}</h5>
        <ul class="list-unstyled footer-list mt-3">
          <li><a routerLink="/about-us" class="text-foot"><i
                class="uil uil-angle-{{'dir-icon' | translate}}-b me-1"></i> {{ 'Footer.AboutUs' | translate }}</a>
          </li>
          <li><a routerLink="/services/invoice" class="text-foot"><i
                class="uil uil-angle-{{'dir-icon' | translate}}-b me-1"></i> {{ 'Footer.Services' | translate }}</a>
          </li>
          <li><a routerLink="/login" class="text-foot"><i class="uil uil-angle-{{'dir-icon' | translate}}-b me-1"></i>
              {{ 'Footer.Login' | translate }}</a></li>
        </ul>
      </div><!--end col-->

      <div class=" footer-col col-lg-2 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
        <h5 class="text-light footer-head">{{ 'Footer.footerHead.UsefullLinks' | translate }}</h5>
        <ul class="list-unstyled footer-list mt-3">
          <li><a routerLink="/terms" target="_blank" class="text-foot"><i
                class="uil uil-angle-{{'dir-icon' | translate}}-b me-1"></i> {{'Footer.TermsOfUse' | translate }}</a>
          </li>
          <li><a routerLink="/faq" target="_blank" class="text-foot"><i
                class="uil uil-angle-{{'dir-icon' | translate}}-b me-1"></i> {{'Footer.FAQAndSupport' | translate }}</a>
          </li>
          <li><a routerLink="/privacy" target="_blank" class="text-foot"><i
                class="uil uil-angle-{{'dir-icon' | translate}}-b me-1"></i> {{'Footer.PrivacyPolicy' | translate }}</a>
          </li>
        </ul>
      </div>

      <div class=" footer-col col-lg-3 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
        <h5 class="text-light footer-head">{{ 'Footer.footerHead.Contact' | translate }}</h5>
        <ul class="list-unstyled footer-list mt-3">
          <li><a href="javascript:void(0)" class="text-foot"><i class="uil uil-envelope px-2"></i>info&#64;easykash.net</a>
          </li>
          <li><a href="javascript:void(0)" class="text-foot"><i class="uil uil-phone px-2"></i> 01285885966 -
              01226486855</a></li>

        </ul>
      </div>
    </div>
  </div>
</footer><!--end footer-->

<footer class="footer footer-bar">
  <div class="container text-center">
    <p class="mb-0">{{ 'Footer.EasyKashInc' | translate }}</p>
  </div>
</footer>
<!-- Footer End -->
